export default "__VITE_ASSET__wd8znSM4__"